import React, { memo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../../settings";
import OverlayReel from "../OverlayReel/OverlayReel";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import { useSelector } from "react-redux";
import { selectHoldAndWinActive } from "../../../State/selectors";

const OverlayReelSet = memo(({ symbolWidth, symbolHeight, reelSpacing }) => {
  const { overlayReelRefs } = useReelRefs();
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  return (
    <Container
      name="spine_overlay"
      zIndex={5}
      y={-symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5)}
      alpha={holdAndWinActive ? 0.001 : 1}
    >
      {GAME_LAYOUT.REEL_INDICES.map((index) => (
        <OverlayReel
          key={index}
          symbolHeight={symbolHeight}
          symbolWidth={symbolWidth}
          reelSpacing={reelSpacing}
          overlaySymbols={GAME_LAYOUT.SYMBOL_INDICES}
          ref={(el) => {
            overlayReelRefs.current[index] = el;
          }}
          index={index}
        />
      ))}
    </Container>
  );
});

export default OverlayReelSet;
